<section *ngIf="this.gameConfig?.sliderName === 'slider'">
  <div id="carouselExampleIndicators" class="carousel slide" data-bs-ride="carousel">
    <div class="carousel-indicators">
      <button type="button" *ngFor="let item of gameConfig.imageList; let i = index;" data-bs-target="#carouselExampleIndicators" attr.data-bs-slide-to="{{i}}" class="{{ (i == 0) ? 'active' : '' }}"
        attr.aria-label="Slide {{i}}"></button>

    </div>
    <div class="carousel-inner container">
      <ng-container *ngFor="let item of gameConfig.imageList; let i = index;">
      <div class="carousel-item" [ngClass]="{'active': i == 0}">
        <div class="row">
          <div class="col-lg-6  ps-lg-5 ps-0 order-1 order-lg-0">
            <div class="carousel-text">
              <h1 class="text-theme-green hero-heading">{{this.gameConfig.header1}}</h1>
              <h2 class="text-theme-green hero-sub-heading">{{this.gameConfig.header2}}</h2>
              <p>{{this.gameConfig.description}}</p>
            </div>
          </div>
          <div class="col-lg-6 text-center order-0 order-lg-1 mt-3 carousel-img">
            <img [src]="item" alt="carousel-1" class=" game-carousel" />
          </div>
        </div>
      </div>
    </ng-container>
    </div>
    <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators"
      data-bs-slide="prev">
      <span class="carousel-control-prev-icon" aria-hidden="true"></span>
      <span class="visually-hidden">Previous</span>
    </button>
    <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators"
      data-bs-slide="next">
      <span class="carousel-control-next-icon" aria-hidden="true"></span>
      <span class="visually-hidden">Next</span>
    </button>
  </div>
</section>

<section *ngIf="this.gameConfig?.sliderName === 'noslider'">
  <div class="">
      <div class="container ">
          <div class="px-60">
              <div class="row">
                  <div class="col-md-6  ps-lg-5 ps-0 order-1 order-md-0">
                      <div class="carousel-text video-text">
                          <!-- <h4>{{portalName}}</h4> -->
                          <h1 class="text-theme-green hero-heading">{{this.gameConfig.header1}}</h1>
              <h2 class="text-theme-green hero-sub-heading">{{this.gameConfig.header2}}</h2>
                          <p>{{this.gameConfig.description}}</p>
                      </div>
                  </div>
                  <div class="col-md-6 text-center order-0 order-md-1 mt-3 carousel-img">
                      <div class="image-warp d-flex" *ngFor="let item of gameConfig.imageList; let i = index;">
                          <img [src]="item" class="img-fluid" alt="image" />
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</section>

<section class="design-responsive-1" *ngIf="this.gameConfig?.sliderName === 'videoSlider'">
  <div class=" hero-banner">
      <div class="container ">
          <div class="px-60">
              <div class="row">
                  <div class="col-md-6  ps-lg-5 ps-0 order-1 order-md-0">
                      <div class="carousel-text video-text">
                        <h1 class="text-theme-green hero-heading">{{this.gameConfig.header1}}</h1>
                        <h2 class="text-theme-green hero-sub-heading">{{this.gameConfig.header2}}</h2>
                        <p>{{this.gameConfig.description}}</p>                          <a href="#" class="btn btn-ghost btn-post mt-0">View</a>
                      </div>
                  </div>
                  <div class="col-md-6 text-center order-0 order-md-1 mt-3 carousel-img">
                      <div class="image-warp d-flex">
                          <div class="swiper mySwiper">
                              <div class="swiper-wrapper">
                                  <div class="swiper-slide" *ngFor="let item of gameConfig.imageList; let i = index;" >
                                      <div class="image-slider img-1">
                                          <img [src]="item" alt="" class="img-fluid">
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</section>

<section class="mb-4 mt-4" *ngIf="this.gameConfig?.downloadUrl">
  <div class="container">
    <div class="row">
      <div class="col-12 d-flex justify-content-between">
        <h3 class="section-heading"><span class="text-theme-green">DownLoad APK</span></h3>
      </div>
      <div class="col-6 col-xl-3 col-md-4 mt-lg-0 mb-2">
        <div class="custom-card">
          <div class="card-img">
              <img (click)="downloadApk('assets/apk/app-premiumgames-v1.3.apk')" src="assets/images/download-button-png.png" alt="card1">
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- <section class="mt-64 design-responsive">
  <div class="container">
    <div class="col-12 d-flex justify-content-between">
      <h3 class="section-heading"><span class="text-theme-green">{{gameConfig.trending}}</span></h3>
    </div>
    <ngx-slick-carousel class="carousel col-6 col-xl-3 col-md-4 mb-lg-0" #slickModal="slick-carousel"
      [config]="slideConfig" >
      <div ngxSlickItem class="slide" *ngFor="let item of trendingList">
        <div class="custom-card" *ngIf="this.gameConfig.name === 'game'">
        
          <div class="card-img" *ngIf="item.cdm_url !== ''">
              <img (click)="gotoHome(item)" [src]="item.cdm_content_path" alt="card1">
          </div>
          <div class="card-img" *ngIf="item.cdm_url === ''">
              <img (click)="gotoHome(item)" src='{{item.cdm_thumbnail_3 != "" ? "https://1477157375.rsc.cdn77.org/repository/content"+item.cdm_thumbnail_3 : "https://1477157375.rsc.cdn77.org/repository/content"+item.cdm_thumbnail_1}}' alt="card1">

          </div>
          <div class="card-text">
            <p class="total-ratings">{{ (item.cdm_title.length>16)? (item.cdm_title | slice:0:15)+'..':(item.cdm_title) }}</p>
          </div>
        </div>
        <div class="custom-card" *ngIf="this.gameConfig.name !== 'game'">
          <div class="card-img">
              <img (click)="gotoHome(item)" src='{{item.cdm_thumbnail_3 != "" ? "https://1477157375.rsc.cdn77.org/repository/content"+item.cdm_thumbnail_3 : "https://1477157375.rsc.cdn77.org/repository/content"+item.cdm_thumbnail_1}}' alt="card1">
          </div>
          <div class="card-text">
            <p class="total-ratings">{{ (item.cdm_title.length>16)? (item.cdm_title | slice:0:15)+'..':(item.cdm_title) }}</p>
          </div>
        </div>
      </div>
    </ngx-slick-carousel>
  </div>
</section> -->



<section class="mb-4 mt-4">
  <div class="container">
    <div class="row">
      <div class="col-12 d-flex justify-content-between">
        <h3 class="section-heading"><span class="text-theme-green">{{gameConfig?.recommended}}</span></h3>
      </div>
      <div class="col-6 col-xl-3 col-md-4 mt-lg-0 mb-2" *ngFor="let item of recommendList">
        <div class="custom-card" *ngIf="this.gameConfig?.name == 'game'">
          <div class="card-img" *ngIf="item.cdm_url != ''">
              <img (click)="gotoHome(item)" [src]="item.cdm_content_path" alt="card1">
\          </div>
          <div class="card-img" *ngIf="item.cdm_url == ''">
              <img (click)="gotoHome(item)" src='{{item.cdm_thumbnail_3 != "" ? "https://1477157375.rsc.cdn77.org/repository/content"+item.cdm_thumbnail_3 : "https://1477157375.rsc.cdn77.org/repository/content"+item.cdm_thumbnail_1}}' alt="card1">
          </div>
          <div class="card-text" *ngIf="this.queryParam.id != '536' && this.queryParam.lang != 'AR'">
            <p class="total-ratings">{{ (item.cdm_title.length>16)? (item.cdm_title | slice:0:15)+'..':(item.cdm_title) }}</p>
          </div>
        </div>
        <div class="custom-card" *ngIf="this.gameConfig?.name != 'game'">
          <div class="card-img">
              <img (click)="gotoHome(item)" src='{{item.cdm_thumbnail_3 != "" ? "https://1477157375.rsc.cdn77.org/repository/content"+item.cdm_thumbnail_3 : "https://1477157375.rsc.cdn77.org/repository/content"+item.cdm_thumbnail_1}}' alt="card1">
          </div>
          <div class="card-text" *ngIf="this.queryParam.id != '536' && this.queryParam.lang != 'AR'">
            <p class="total-ratings">{{ (item.cdm_title.length>16)? (item.cdm_title | slice:0:15)+'..':(item.cdm_title) }}</p>
          </div>
        </div>
      </div>
    </div>
    
  </div>
</section>

<section class="mb-4 mt-4" *ngIf="this.queryParam.id == '16'">
  <div class="container"> 
    <div class="row">
      <div class="col-12 d-flex justify-content-between">
        <h3 class="section-heading"><span class="text-theme-green">GAMES</span></h3>
      </div>
      <div class="col-6 col-xl-3 col-md-4 mt-lg-0 mb-2" *ngFor="let item of this.res.contentmapping">
        <div class="custom-card" *ngIf="this.gameConfig?.name == 'game'">
          <div class="card-img" *ngIf="item.cdm_url != ''">
            <!-- <a href="./assets/detail.html"> -->
              <img (click)="gotoHome(item)" [src]="item.cdm_content_path" alt="card1">
            <!-- </a> -->
          </div>
          <div class="card-img" *ngIf="item.cdm_url == ''">
            <!-- <a href="./assets/detail.html"> -->
              <img (click)="gotoHome(item)" src='{{item.cdm_thumbnail_3 != "" ? "https://1477157375.rsc.cdn77.org/repository/content"+item.cdm_thumbnail_3 : "https://1477157375.rsc.cdn77.org/repository/content"+item.cdm_thumbnail_1}}' alt="card1">
            <!-- </a> -->
          </div>
          <div class="card-text">
            <p class="total-ratings">{{ (item.cdm_title.length>16)? (item.cdm_title | slice:0:15)+'..':(item.cdm_title) }}</p>
          </div>
        </div>
        <div class="custom-card" *ngIf="this.gameConfig?.name != 'game'">
          <div class="card-img">
            <!-- <a href="./assets/detail.html"> -->
              <img (click)="gotoHome(item)" src='{{item.cdm_thumbnail_3 != "" ? "https://1477157375.rsc.cdn77.org/repository/content"+item.cdm_thumbnail_3 : "https://1477157375.rsc.cdn77.org/repository/content"+item.cdm_thumbnail_1}}' alt="card1">
            <!-- </a> -->
          </div>
          <div class="card-text">
            <p class="total-ratings">{{ (item.cdm_title.length>16)? (item.cdm_title | slice:0:15)+'..':(item.cdm_title) }}</p>
          </div>
        </div>
      </div>
    </div>
    
  </div>
</section>


  <section *ngIf="this.gameConfig?.list && this.queryParam.id != '16'" >
    <div class="container px-0">
      <nav class="navbar navbar-expand-lg">
            <button class="navbar-toggler" type="button" data-bs-toggle="collapse"
              data-bs-target="#navbarSupportedContent1" aria-controls="navbarSupportedContent" aria-expanded="false"
              aria-label="Toggle navigation">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="12" viewBox="0 0 18 12">
                <path id="Path_39032" data-name="Path 39032"
                  d="M4,18H20a1,1,0,0,0,0-2H4a1,1,0,0,0,0,2Zm0-5H20a1,1,0,0,0,0-2H4a1,1,0,0,0,0,2ZM3,7A1,1,0,0,0,4,8H20a1,1,0,0,0,0-2H4A1,1,0,0,0,3,7Z"
                  transform="translate(-3 -6)" fill="#fff" />
              </svg>
            </button>
          <div class="collapse navbar-collapse" id="navbarSupportedContent1">
            <ul class="navbar-nav align-items-center">
                <li class="nav-link fontColor" [class.active]="selectedIndex === i"
                (click)="setIndex(i)" data-tab="tab-1" *ngFor="let menu of menu; let i = index;" (click)="getButtonCategories(menu.url)">
                  <a>{{menu.title}}</a></li>
            </ul>
          </div>
      </nav>
      <div id="tab-1" class="tab-content current">
        <div class="row">
          <div class="col-6 col-xl-3 col-md-4" *ngFor="let item of contentList">
            <div class="custom-card" style="margin-bottom: 20px;" *ngIf="this.gameConfig?.name === 'game'">
              <div class="card-img" *ngIf="item.cdm_url != ''">
                <!-- <a href="./assets/detail.html"> -->
                  <img (click)="gotoHome(item)" [src]="item.cdm_content_path" alt="card1">
                <!-- </a> -->
              </div>
              <div class="card-img" *ngIf="item.cdm_url == ''">
                <!-- <a href="./assets/detail.html"> -->
                  <img (click)="gotoHome(item)" src='{{item.cdm_thumbnail_3 != "" ? "https://1477157375.rsc.cdn77.org/repository/content"+item.cdm_thumbnail_3 : "https://1477157375.rsc.cdn77.org/repository/content"+item.cdm_thumbnail_1}}' alt="card1">
                  <!-- </a> -->
              </div>
              <div class="card-text" *ngIf="this.queryParam.id != '536' && this.queryParam.lang != 'AR'">
                <p class="total-ratings">{{ (item.cdm_title.length>16)? (item.cdm_title | slice:0:15)+'..':(item.cdm_title) }}</p>
              </div>
            </div>

            <div class="custom-card" style="margin-bottom: 20px;" *ngIf="this.gameConfig?.name != 'game'">
              <div class="card-img">
                <!-- <a href="./assets/detail.html"> -->
                  <img (click)="gotoHome(item)" src='{{item.cdm_thumbnail_3 != "" ? "https://1477157375.rsc.cdn77.org/repository/content"+item.cdm_thumbnail_3 : "https://1477157375.rsc.cdn77.org/repository/content"+item.cdm_thumbnail_1}}' alt="card1">
                  <!-- </a> -->
              </div>
              <div class="card-text" *ngIf="this.queryParam.id != '536' && this.queryParam.lang != 'AR'">
                <p class="total-ratings">{{ (item.cdm_title.length>16)? (item.cdm_title | slice:0:15)+'..':(item.cdm_title) }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>



